import { Wrapper } from 'lib/noop-wrapper'
import React from 'react'
import { allDefaultSort, allDefaultTab } from 'New/community'

export function makeCommunityUrl({
  id,
  tab = allDefaultTab,
  sort = allDefaultSort,
  page,
}: {
  id: string
  tab?: string
  sort?: string
  page?: number
}) {
  const tabSort =
    sort === allDefaultSort
      ? tab === allDefaultTab
        ? ''
        : tab === 'all'
        ? 'wenda'
        : tab
      : `${tab}-${sort}`

  const realPage = page && page > 1 ? page : ''

  const append = tabSort
    ? `${tabSort}${realPage ? `-${realPage}` : ''}`
    : realPage

  return `/community/${id}${append ? `/${append}` : ''}`
}

interface ICommunityLink {
  id?: string
  tab?: string
}

function communityLink({ id, tab }: ICommunityLink): Wrapper {
  const herf =
    id && tab === 'koubei' ? `/auto/series/score/${id}-x-x-x-x-x-x` : ''

  // const herf = id
  //   ? `/community/${id}${tab ? `/${tab}` : ''}`
  //   : `/car_fans_community`
  // const as = id
  //   ? `/community/${id}${tab ? `/${tab}` : ''}`
  //   : `/car_fans_community`

  return (content) =>
    id ? (
      <React.Fragment>
        <a target={'_blank'} href={herf || makeCommunityUrl({ id, tab })}>
          {content}
        </a>
        <style jsx>
          {`
            a {
              color: inherit;
            }
          `}
        </style>
      </React.Fragment>
    ) : (
      content
    )
}

export function allCommunityLink(): Wrapper {
  return (content) => (
    <React.Fragment>
      <a target={'_blank'} href={`/car_fans_community`}>
        {content}
      </a>
      <style jsx>
        {`
          a {
            color: inherit;
          }
        `}
      </style>
    </React.Fragment>
  )
}

export default communityLink
